import React, { useState } from "react";
import { Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import { CompassLogo } from "@/components/CompassLogo";
import { useLang } from "@/i18n/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { UI, t } from "@/i18n/translations";
import { api } from "@/lib/api";
import { LegalConsentText } from "@/components/LegalConsentText";

export default function LegalGate() {
  const { lang } = useLang();
  const { setUser } = useAuth();
  const L = UI.legal;
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    if (!checked) { toast.error(t(L.required, lang)); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/legal/accept", { accepted: true });
      setUser(data);
    } catch {
      toast.error(UI.common.error[lang]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-paper text-ink grid place-items-center px-5" data-testid="legal-gate">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-6"><CompassLogo size={30} /><span className="font-display text-lg font-extrabold">Boussole</span></div>
        <div className="grid place-items-center w-16 h-16 rounded-[20px] bg-ink mb-5"><FileText className="w-8 h-8 text-amber" /></div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight">{t(L.gateTitle, lang)}</h1>
        <p className="text-sm text-ink/60 mt-2 mb-5">{t(L.gateBody, lang)}</p>
        <label className="flex items-start gap-3 rounded-2xl border border-line bg-white p-4 cursor-pointer">
          <input data-testid="legal-gate-checkbox" type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-0.5 w-5 h-5 accent-sage shrink-0" />
          <span className="text-sm text-ink/80 leading-relaxed"><LegalConsentText /></span>
        </label>
        <button data-testid="legal-gate-accept" onClick={accept} disabled={busy} className="w-full mt-4 rounded-2xl bg-amber text-ink font-bold py-3.5 flex items-center justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} {t(L.continue, lang)}
        </button>
      </div>
    </div>
  );
}
